import { EPageTypes, EPlatformTypes, handleDynamicCalltracking } from '@cian/frontend-newbuilding-call-component';
import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';

const PLACE_TYPE = 'newbuilding_card';
interface IRequestDynamicPhoneParams {
  httpApi: IHttpApi;
  logger: ILogger;
  entityId: number;
  platformType: EPlatformTypes;
  siteBlockId?: number | null;
}

export async function requestDynamicPhone({
  httpApi,
  logger,
  entityId,
  platformType,
  siteBlockId,
}: IRequestDynamicPhoneParams): Promise<string | null> {
  if (!siteBlockId) {
    return null;
  }

  const { notFormattedPhone } = await handleDynamicCalltracking({
    httpApi,
    logger,
    blockId: siteBlockId,
    platformType,
    pageType: EPageTypes.Favorites,
    placeType: PLACE_TYPE,
    announcementId: entityId,
  });

  return notFormattedPhone;
}
